import { createContext, useReducer, useState, useContext } from 'react'

export const UnitContext = createContext() 

export const unitReducer = (state, action) => {
    switch (action.type) {
        case 'SET_UNIT':
            return { units: action.payload }
        case 'CREATE_UNIT':
            return { units: [action.payload, ...state.units] }
        case 'UPDATE_UNIT':
            return { units: action.payload }
        case 'DELETE_UNIT':
            return { units: state.units.filter(u => u._id !== action.payload._id) }
        case 'RESET_UNIT':
            return { units: action.payload }
        case 'SET_SELECTABLE_UNITS':
            return { ...state, selectableUnits: action.payload };
        case 'UPDATE_UNIT_RADIUS':
            return {
                ...state,
                units: state.units.map(u =>
                    u._id === action.payload._id
                        ? { ...u, syntheticRadius: action.payload.syntheticRadius }
                        : u
                )
            }
        default:
            return state
    }
}

export const UnitContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(unitReducer, { units: [], selectableUnits: [], targetUnit: null  })
    const [targetUnit, setTargetUnit] = useState(null)
    return (
        <UnitContext.Provider value={{ ...state, dispatch, targetUnit, setTargetUnit}}>
            { children }
        </UnitContext.Provider>
    )
}

export const useUnitContext = () => {
    const context = useContext(UnitContext)
    if(!context) throw Error('useUnitContext must be used inside an UnitContextProvider')
    return context
}